/**
 ** auth
 */

//import layoutAuth from '@/langs/fr/layout/auth.js'
import pageAuthLogin from '@/langs/fr/pages/auth/login.js'
import pageLanding from '@/langs/fr/pages/landing.js'

import pageCgv from '@/langs/fr/pages/cgv.js'
import pageConfidentiality from '@/langs/fr/pages/confidentialy.js'
import pageMention from '@/langs/fr/pages/mention.js'

import pageAuthRecoverPassword from '@/langs/fr/pages/auth/recover-password.js'
import pageAuthSetNewPassword from '@/langs/fr/pages/auth/set-new-password.js'

export default {
  pageAuthLogin,
  pageLanding,
  pageAuthRecoverPassword,
  pageAuthSetNewPassword,
  
  pageCgv,
  pageConfidentiality,
  pageMention,
}